// src/pages/TermsPage.js
import React from "react";
import { FiFileText, FiMail, FiCalendar } from "react-icons/fi";

const TermsPage = () => {
  return (
    <div className="bg-theme-bg min-h-screen py-20 px-4">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="bg-white rounded-[40px] border border-component-border p-12 mb-8 shadow-sm text-center md:text-left">
          <div className="w-16 h-16 bg-orange-50 text-chafadi-primary rounded-2xl flex items-center justify-center text-3xl mb-8 mx-auto md:mx-0">
            <FiFileText />
          </div>
          <h1 className="text-4xl md:text-5xl font-black text-theme-text tracking-tight mb-4 font-display">General Conditions of Use</h1>
          <div className="flex items-center justify-center md:justify-start gap-2 text-theme-muted font-black text-[10px] uppercase tracking-widest">
            <FiCalendar className="text-chafadi-primary" />
            Last Updated: July 14, 2025
          </div>
        </div>

        {/* Content */}
        <div className="bg-white rounded-[40px] border border-component-border p-8 md:p-12 shadow-sm space-y-12">
          <section className="space-y-4">
            <h2 className="text-2xl font-black text-theme-text flex items-center gap-3">
              <span className="w-8 h-8 rounded-lg bg-theme-bg flex items-center justify-center text-xs text-chafadi-primary">1</span>
              Agreement to Terms
            </h2>
            <p className="text-theme-muted font-medium leading-relaxed">
              By using our services ("Services"), you agree to be bound by these
              General Conditions of Use ("GCU"). These terms govern your access to
              and use of the Chafadi application and services, operated by Quivix.
              If you do not agree to these terms, you may not access or use the
              Services.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-black text-theme-text flex items-center gap-3">
              <span className="w-8 h-8 rounded-lg bg-theme-bg flex items-center justify-center text-xs text-chafadi-primary">2</span>
              User Accounts
            </h2>
            <p className="text-theme-muted font-medium leading-relaxed">
              When you create an account with us, you must provide us information
              that is accurate, complete, and current at all times. Failure to do
              so constitutes a breach of the Terms, which may result in immediate
              termination of your account on our Service. You are responsible for
              safeguarding the password that you use to access the Service and for
              any activities or actions under your password.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-black text-theme-text flex items-center gap-3">
              <span className="w-8 h-8 rounded-lg bg-theme-bg flex items-center justify-center text-xs text-chafadi-primary">3</span>
              Content Responsibility
            </h2>
            <p className="text-theme-muted font-medium leading-relaxed">
              Our Service allows you to post, link, store, share and otherwise
              make available certain information, text, graphics, videos, or other
              material ("Content"). You are responsible for the Content that you
              post to the Service, including its legality, reliability, and
              appropriateness. As a seller, you grant us the right and license to
              use, modify, publicly perform, publicly display, reproduce, and
              distribute such Content on and through the Service.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-black text-theme-text flex items-center gap-3">
              <span className="w-8 h-8 rounded-lg bg-theme-bg flex items-center justify-center text-xs text-chafadi-primary">4</span>
              Prohibited Activities
            </h2>
            <p className="text-theme-muted font-medium leading-relaxed mb-6">
              You may use the Service only for lawful purposes. You agree not to
              use the Service:
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {[
                "Violating any national/international laws.",
                "Engaging in fraudulent trading activities.",
                "Selling counterfeit or prohibited goods.",
                "Impersonating company staff or other users.",
                "Misrepresenting products or shipping rates.",
                "Systematically scraping platform data."
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-3 p-4 bg-theme-bg rounded-2xl border border-component-border">
                  <div className="w-2 h-2 rounded-full bg-rose-500" />
                  <span className="text-xs font-black text-theme-text uppercase tracking-widest">{item}</span>
                </div>
              ))}
            </div>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-black text-theme-text flex items-center gap-3">
              <span className="w-8 h-8 rounded-lg bg-theme-bg flex items-center justify-center text-xs text-chafadi-primary">5</span>
              Termination
            </h2>
            <p className="text-theme-muted font-medium leading-relaxed">
              We may terminate or suspend your account immediately, without prior
              notice or liability, for any reason whatsoever, including without
              limitation if you breach the Terms.
            </p>
          </section>

          <section className="pt-8 border-t border-component-border">
            <div className="bg-theme-bg rounded-3xl p-8 flex flex-col md:flex-row items-center gap-8 border border-component-border">
              <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center text-chafadi-primary text-2xl shadow-sm border border-component-border">
                <FiMail />
              </div>
              <div className="text-center md:text-left">
                <h3 className="text-xl font-black text-theme-text mb-2">Legal inquiries?</h3>
                <p className="text-theme-muted font-medium">For all legal questions regarding these terms, contact <a href="mailto:support@chafadi.com" className="text-chafadi-primary font-black border-b-2 border-chafadi-primary/20 hover:border-chafadi-primary transition-all">support@chafadi.com</a></p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
